import image1 from '@/assets/news/20211013_1.jpg'
import image2 from '@/assets/news/20211013_2.jpg'
import image3 from '@/assets/news/20211013_3.png'
import image4 from '@/assets/news/20211013_4.png'

export default {
  zh: {
    title: '合生基因与伟杰信生物签约联合研发新型兽用疫苗',
    abstract: '2021年10月13日，北京合生基因科技有限公司与北京伟杰信生物科技有限公司签订战略合作协议。合生基因致力于应用合成生物技术研究、开发新型基因与细胞治疗药物',
    cover: image1,
    content: `
  <div style="text-align:center"><img src="${image1}"></img></div>
  <p>2021年10月13日，北京合生基因科技有限公司与北京伟杰信生物科技有限公司签订战略合作协议。合生基因致力于应用合成生物技术研究、开发新型基因与细胞治疗药物；北京伟杰信聚焦动保领域创新药的研发、生产和销售，是高端动物蛋白药的领跑者。</p>
  <p>近年非洲猪瘟疫情的爆发以及已有动物病原的快速变异给我国乃至世界畜牧业的发展带来重创，严重影响了我国肉类食品的供应和安全保障。随着畜牧业向着高度规模化、集约化和现代化的方向快速发展，新发疫病或菌、毒株变异导致的动物疫病呈现增长趋势，这对疫苗研发企业提出了更高的挑战和要求。目前已有的某些疫苗品种存在制定免疫程序难、免疫剂量逐步加大，免疫效率低等痛点问题，所以合生基因和北京伟杰信希望通过本次合作，强强联合，发挥各自优势，形成合力，努力攻克目前兽用疫苗开发中的痛点、难点和掐脖子技术。</p>
  <div style="text-align:center"><img src="${image2}"></img></div>
  <h3>关于合生基因</h3>
  <div style="text-align:center"><img src="${image3}" style="width:160px"></img></div>
  <p>合生基因是中国首家致力于合成生物技术在生物医药领域应用的高新技术企业。合生基因致力于利用合成生物技术开发针对癌症、遗传病、传染性疾病的创新药物和治疗方法，构建基于合成生物技术的生物医药新生态。通过合理设计构建新型基因、免疫细胞和RNA核酸药物，提高药物研发成功率、有效性和安全性。值得关注的是，合生基因持续加码布局以合成生物技术为基础的下一代生物药物智能制造平台开发，在合成医学生物学方向处于国际领先水平，相关溶瘤病毒产品已获得 NMPA 及 FDA 一期临床试验许可。</p>
  <h3>关于伟杰信生物</h3>
  <div style="text-align:center"><img src="${image4}" style="width:150px"></img></div>
  <p>北京伟杰信生物科技有限公司聚焦动保领域创新药的研发、生产和销售，是高端动物蛋白药的领跑者。公司在研产品管线包含 10 个创新药品种，覆盖动物繁殖、疾病防控及宠物蛋白药三个领域，其中多个品种为全球重磅首创产品，并且已有品种 NDA。公司在新型兽药开发领域，搭建了多个技术平台，如：特定动物 B 细胞天然免疫库、特定动物抗体种属同源化技术等。</p>
    `
  }
}
